export default __webpack_public_path__ + "static/6-c58bfc8dd540bf2f45be40886c7c81b5.webp";